import { Component, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { GridContext, GenericColDef, CellTemplateType, FilterTemplateType } from '../../../models/grid-context';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import * as _ from 'underscore';
import { ProjectListItem } from '../../../models/project-list-item';
import { CommonService } from '../../../services/common/common.service';
import { Permissions, ObjectActionListType } from '../../../models/permission';
import { MessageType } from '../../../models/enums';
import { Subscription } from 'rxjs';
import { DrObject } from '../../../models/dr-object';

@Component({
    standalone: false,
    templateUrl: './grid-header.component.html',
    styleUrls: ['./grid-header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GridHeaderComponent implements IHeaderAngularComp, OnDestroy {

    @Input() pickerConfig: Partial<BsDaterangepickerConfig>;

    debounceFilter = _.debounce(this.filterAfterBounce, 1000);

    params: IHeaderParams;
    colDef: GenericColDef;
    gridContext: GridContext;
    automationId: string;
    filterValue = '';

    multiChoiceFilter: boolean;
    ownerSingleChoiceFilter: boolean;
    ownerSingleChoiceSelected: any;
    rangeFilter: boolean;
    dateFilter: boolean;
    freeform: boolean;
    isReadOnly: true;
    isOpen: boolean;
    multiChoiceFilterData: any;
    ownerSingleChoiceFilterData: any;
    rangeFilterData: any;
    filterValueDatePicker: any;
    filteredItems: any;
    singleChoiceFilterData: any;
    singleChoiceFilter: boolean;
    singleChoiceSelected: any;
    comboBoxFilterData: any;
    comboBoxFilter: boolean;
    showIconButtonsFilter: boolean;
    isSingleIconSelection: boolean;
    iconSelectionTitle: string;
    iconSelectionFilterValue: string;
    activeIconButtonSelection: boolean;

    private closeAllDatePickers: Subscription;
    private gridHeadersHidden: Subscription;
    private updateGridFiltering: Subscription;

    constructor(private commonService: CommonService) {
        this.gridHeadersHidden = this.commonService.getMessage(MessageType.gridHeadersChanged).subscribe((data) => {
            this.datePickerPosition(data);
        });
        this.updateGridFiltering = this.commonService.getMessage(MessageType.filterGridHeadersChanged).subscribe((data) => {
            this.updateFilterGrid(data.colDef, data.filterValue, data.isClearFilter);
        });
    }

    agInit(params: IHeaderParams): void {
        this.isOpen = false;
        this.filterValueDatePicker = [];
        const todayDate = new Date();
        this.filterValueDatePicker = [todayDate, todayDate];

        this.multiChoiceFilterData = { filterValue: '', selectAll: false, items: [] };
        this.rangeFilterData = { start: '', end: '' };

        this.params = params;
        if (this.params) {
            this.colDef = this.params.column.getColDef() as GenericColDef;
            this.gridContext = this.params.context as GridContext;
            this.gridContext.clearAllFilters.subscribe(value => this.onClearAllHeaderFilters());
            this.gridContext.clearAllFilterInputs.subscribe(value => this.onClearAllHeaderFilterInputs());
            if (this.colDef) {
                this.automationId = `${this.colDef.automationId ? this.colDef.automationId + '-' : ''}grid-header-cell`;
                let name = this.colDef.headerName || this.colDef.colId || this.colDef.field ||
                    (this.colDef.cellTemplateType === CellTemplateType.contextMenu ? 'options' : '');
                if (this.colDef.automationIdParsed && this.colDef.automationIdCustom) {
                    const copyUntilEnd = this.automationId.indexOf('grid-cell');
                    if (copyUntilEnd !== -1) {
                        this.automationId = this.automationId.slice(0, copyUntilEnd);
                        this.automationId += 'grid-header-cell';
                    }
                } else if (this.colDef?.colId === 'aliasListCustomAutomationId') {
                    name = 'alias-name';
                } else if (this.colDef?.colId === 'domainListCustomAutomationId') {
                    name = 'domain-name';
                }
                name = name.replace(/%/g, 'percent');
                name = name.replace(/[^a-zA-Z0-9-_ ]/gi, '');
                if (name && this.colDef.filterType !== FilterTemplateType.date) {
                    this.automationId += `-${name.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase()}`;
                }
                if(this.colDef.headerAutomationId) {
                    this.automationId = this.colDef.headerAutomationId;
                }
            }

            switch (this.colDef.filterType) {
                case (FilterTemplateType.singleChoice):
                    this.singleChoiceFilter = true;
                    this.singleChoiceSelected = this.colDef.filterItemSelected;
                    this.singleChoiceFilterData = this.colDef.filterItems ? this.colDef.filterItems : [' '];
                    break;
                case (FilterTemplateType.comboBox):
                    this.comboBoxFilter = true;
                    this.comboBoxFilterData = this.colDef.filterItems ? this.colDef.filterItems : [' '];
                    break;
                case (FilterTemplateType.ownerSingleChoice):
                    this.ownerSingleChoiceFilter = true;
                    this.ownerSingleChoiceSelected = this.commonService.currentUser.userName;
                    if (Permissions.checkUserPermission(ObjectActionListType.AUDIT_LOG)) {
                        this.ownerSingleChoiceFilterData = ['All', this.ownerSingleChoiceSelected];
                    } else {
                        this.ownerSingleChoiceFilterData = [this.ownerSingleChoiceSelected];
                    }
                    if (this.colDef.headerName === 'Status') {
                        this.ownerSingleChoiceSelected = this.colDef.filterItemSelected;
                        this.ownerSingleChoiceFilterData = this.colDef.filterItems;
                    }
                    break;
                case (FilterTemplateType.date):
                    this.closeAllDatePickers = this.commonService.getMessage(MessageType.closeAllDatePickers).subscribe((data) => {
                        if (data.colDef !== this.colDef) {
                            this.isOpen = false;
                        }
                    });
                    break;
                case FilterTemplateType.singleIconButtonSelection:
                case FilterTemplateType.multipleIconsButtonSelection:
                    this.showIconButtonsFilter = true;
                    this.activeIconButtonSelection = this.colDef.applyFilterOnLoad;
                    this.isSingleIconSelection = this.colDef.filterType === FilterTemplateType.singleIconButtonSelection ? true : false;
                    this.iconSelectionTitle = this.colDef.filterType === FilterTemplateType.singleIconButtonSelection ? "Filter by 'Failure'" : "Filter by 'Warning / Partial Failure' or 'Critical / Failure'";
                    this.iconSelectionFilterValue = this.colDef.filterType === FilterTemplateType.singleIconButtonSelection ? 'FAILURE CRITICAL' : 'PARTIAL_FAILURE WARNING FAILURE CRITICAL UNKNOWN';
                    break;
                default:
                    this.ownerSingleChoiceFilter = false;
                    break;
            }
        }
    }

    refresh(): boolean {
        return false;
    }

    onHeaderClick(event: MouseEvent): void {
        if (this.colDef && this.gridContext && this.colDef.sortBy && this.gridContext.sortEnabled) {
            this.gridContext.onHeaderClick(this.colDef.sortBy, this.gridContext.sortBy === this.colDef.sortBy ?
                !this.gridContext.sortAscending : this.colDef.defaultSortAscending === false ? false : true);
        }
    }

    onHeaderContextMenu(event: MouseEvent): void {
        if (this.colDef && this.gridContext && this.gridContext.onHeaderContextMenu) {
            this.gridContext.onHeaderContextMenu(this.colDef, event);
        }
    }

    onFilter(event?: Event): void {
        this.changeFilterState(event);
    }

    onFilterCancel(event?: Event): void {
        this.changeFilterState(event);
    }

    onFilterApply(event?): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.colDef.filterType === FilterTemplateType.multiChoice) {
            const items = _.filter(this.filteredItems, (item) => item.selected);
            this.filterValue = items.map(i => i.name).join(', ');
            this.multiChoiceFilter = false;
            this.gridContext.onFilterApply(this.filterValue, this.colDef.filterType, this.colDef.headerName);
        }

        if (this.colDef.filterType === FilterTemplateType.range && this.rangeFilterData.start && this.rangeFilterData.end) {
            this.filterValue = this.rangeFilterData.start + ' ~~ ' + this.rangeFilterData.end;
            this.rangeFilter = false;
            this.gridContext.onFilterApply(this.filterValue, this.colDef.filterType, this.colDef.headerName);
        }
        if (this.colDef.filterType === FilterTemplateType.freeform || this.colDef.filterType === FilterTemplateType.comboBox) {
            this.debounceFilter(this.filterValue.trim());
        }
        if (this.colDef.filterType === FilterTemplateType.ownerSingleChoice) {
            this.gridContext.onFilterApply(this.ownerSingleChoiceSelected, this.colDef.filterType, this.colDef.headerName);
        }
        if (this.colDef.filterType === FilterTemplateType.singleChoice) {
            this.gridContext.onFilterApply(this.singleChoiceSelected, this.colDef.filterType, this.colDef.headerName);
        }
        if (this.colDef.filterType === FilterTemplateType.date) {
            this.gridContext.onFilterApply(this.filterValue, this.colDef.filterType, this.colDef.headerName);
        }
    }

    filterAfterBounce(str: string): void {
        this.gridContext.onFilterApply(this.filterValue.trim(), this.filterValue === '' ? FilterTemplateType.clear : this.colDef.filterType, this.colDef.headerName, null, null, false);
    }

    changeFilterState(event?: Event): void {
        if (this.colDef.filterType === FilterTemplateType.multiChoice) {
            this.multiChoiceFilter = !this.multiChoiceFilter;
            if (this.multiChoiceFilter) {
                if (this.gridContext.filterData instanceof ProjectListItem) {
                    this.multiChoiceFilterData.items = this.gridContext.filterData[0].children.filter(t => t.name);
                } else {
                    this.multiChoiceFilterData.items = this.gridContext.filterData.filter(t => t.name);
                }
                this.assignCopy();
                if (this.multiChoiceFilterData.selectAll) {
                    this.selectAllItems(this.multiChoiceFilterData.selectAll);
                }
            }
        }

        if (this.colDef.filterType === FilterTemplateType.range) {
            this.rangeFilter = !this.rangeFilter;
        }

        if (this.colDef.filterType === FilterTemplateType.date) {
            this.dateFilter = !this.dateFilter;
            setTimeout(() => {
                this.isOpen = !this.isOpen;
                if (this.isOpen) {
                    this.datePickerPosition();
                }
            }, 100);
        }
    }

    onBlur(): void {
        return;
    }

    onFocus(): void {
        this.commonService.sendMessage(MessageType.closeAllDatePickers, { colDef: this.colDef });
    }

    onFunnelOrClearClick(event?: Event): void {
        if (this.filterValue.trim()) {
            this.clearFilter();
        } else {
            this.onFocus();
            if (this.colDef.filterType !== FilterTemplateType.freeform) {
                this.onFilter(event);
            }
        }
    }

    onClearAllHeaderFilters(): void {
        this.activeIconButtonSelection = false;
        this.onClearAllHeaderFilterInputs();
        this.gridContext.onFilterApply(this.filterValue, FilterTemplateType.clear, this.colDef.headerName, true);
    }

    onClearAllHeaderFilterInputs(): void {
        this.filterValue = '';
        const todayDate = new Date();
        this.filterValueDatePicker = [todayDate, todayDate];

        this.multiChoiceFilterData = { filterValue: '', selectAll: false, items: [] };
        this.rangeFilterData = { start: '', end: '' };
        this.singleChoiceSelected = this.singleChoiceFilterData ? this.singleChoiceFilterData[0] : '';
    }

    clearFilter(): void {
        this.onFocus();
        this.filterValue = '';
        if (this.colDef.filterType === FilterTemplateType.date) {
            this.filterValueDatePicker = [];
        }
        this.gridContext.onFilterApply(this.filterValue, FilterTemplateType.clear, this.colDef.headerName, null, null, true);
    }

    clearMultiChiceFilterData(): void {
        this.multiChoiceFilterData.filterValue = '';
        this.multiChoiceFilterData.selectAll = false;
        this.assignCopy();
    }

    onDateChange($event): void {
        this.filterValue = $event;
        this.onFilterApply();
    }

    assignCopy(): void {
        if (!this.multiChoiceFilterData.filterValue) {
            this.filteredItems = Object.assign([], this.multiChoiceFilterData.items);
        }
    }

    filterItem(value): void {
        if (!value) {
            this.assignCopy();
        }
        this.filteredItems = Object.assign([], this.multiChoiceFilterData.items).filter(
            item => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
    }

    selectAllItems(value): void {
        this.filteredItems.forEach(item => {
            item.selected = value;
        });
    }

    datePickerPosition(colDef?): any {
        setTimeout(() => {

            if (colDef?.filterType === FilterTemplateType.date && colDef?.headerName === this.colDef.headerName) {
                this.onDatePickerCancel();
                return;
            }
            const pickerContainer: any = document.getElementById('dateTimePickerContainer' + this.colDef.field);
            if (pickerContainer) {
                pickerContainer.style.opacity = 0;
            }

            if (pickerContainer) {
                const pos = pickerContainer?.firstChild.getBoundingClientRect();
                const range = pos.right + 50;
                if (range > document?.body?.clientWidth) {
                    pickerContainer.style.float = 'right';
                    pickerContainer.style.opacity = 1;
                    return;
                }
                const rangeLeft = pos.left;
                if (rangeLeft < 250) {
                    pickerContainer.style.float = 'left';
                    pickerContainer.style.opacity = 1;
                    return;
                }
                pickerContainer.style.opacity = 1;
            }
        });
    }

    updateFilterGrid(colDef?: any, filterValue?: string, isClearFilter?: boolean): any {
        setTimeout(() => {
            if (this.colDef?.colId === colDef?.colId) {
                this.filterValue = filterValue;
                if (!isClearFilter) {
                    document.getElementById("freeform-filter-field-name")?.focus();
                }
            }
        });
    }

    onSelectionComboBoxChanged = (item: any): void => {
        if (item !== this.filterValue) {
            const oldFilerValue = this.filterValue;
            this.filterValue = item;
            if (!DrObject.isEmpty(item) || (DrObject.isEmpty(item) && !DrObject.isEmpty(oldFilerValue))) {
                this.onFilterApply();
            }
        }
    }

    onDatePickerApply = (item): void => {
        if (item) {
            this.isOpen = !this.isOpen;
            this.onDateChange(item);
        }
    }

    onDatePickerCancel = (): void => {
        this.isOpen = !this.isOpen;
    }

    ngOnDestroy(): void {
        if (this.closeAllDatePickers) {
            this.closeAllDatePickers.unsubscribe();
        }
        if (this.gridHeadersHidden) {
            this.gridHeadersHidden.unsubscribe();
        }
        if (this.updateGridFiltering) {
            this.updateGridFiltering.unsubscribe();
        }
    }

    onIconClickSelection(event: Event): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.activeIconButtonSelection) {
            this.activeIconButtonSelection = false;
            this.gridContext?.onFilterApply(this.iconSelectionFilterValue, FilterTemplateType.clear, this.colDef?.headerName);
        } else {
            this.activeIconButtonSelection = true;
            this.gridContext?.onFilterApply(this.iconSelectionFilterValue, this.colDef?.filterType, this.colDef?.headerName);
        }
    }
}
